import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import { currentAppEnv, isProdEnv } from "../data/env-constants";
import { getCurrentReleaseVersion } from "../helpers/common-helper";
import { getSentryMetaInfo } from "../helpers/sentry-helpers";

export const initSentry = () => {
  const { rmpVersion: releaseVersion } = getCurrentReleaseVersion();

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: currentAppEnv,
    release: releaseVersion,

    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    tracesSampleRate: isProdEnv ? 0.2 : 1.0, // lower in prod to reduce volume
    sampleRate: isProdEnv ? 1.0 : 1.0,
    tracePropagationTargets: ["*"],

    sendDefaultPii: true, // enable PII collection

    enableLogs: true,
  });

	// Global event processor to enrich all events with additional context
  Sentry.addEventProcessor((event) => {
    const metaInfo = getSentryMetaInfo();
    return {
      ...event,
      tags: {
        ...event.tags,
        ...metaInfo,
      },
      // contexts: {
      //   ...event.contexts,
      //   metaInfo: metaInfo,
      // },
    };
  });
};
